import React from 'react';
import { useTenant } from '../../contexts/TenantContext';
import { cn } from '../../lib/utils';

interface LegalHeroProps {
  title: string;
  subtitle: string;
  icon?: React.ReactNode;
  label?: string;
  version?: string;
  updated?: string;
}

export const LegalHero: React.FC<LegalHeroProps> = ({ title, subtitle, icon, label, version, updated }) => {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-2 border-b-[8px] border-black dark:border-white min-h-[50vh] bg-black text-white dark:bg-white dark:text-black mb-24">
      <div className="p-8 pt-28 md:p-16 md:pt-32 lg:p-10 lg:pt-32 xl:p-16 xl:pt-40 2xl:p-24 flex flex-col justify-center h-full border-b-[8px] lg:border-b-0 lg:border-r-[8px] border-black dark:border-white bg-white dark:bg-black text-black dark:text-white">
        <h1 className="text-5xl sm:text-6xl md:text-8xl lg:text-6xl xl:text-7xl 2xl:text-[84px] font-black uppercase tracking-tighter leading-[0.85] mb-8 break-words">
          {title.split(' ').map((word, i) => (
            <React.Fragment key={i}>
              {word} {i === 0 ? <br/> : ' '}
            </React.Fragment>
          ))}
        </h1>
        <p className="text-xl md:text-2xl font-bold leading-snug mb-12">
          {subtitle}
        </p>
        {version && updated && (
          <div className="flex items-center gap-4 text-sm font-mono uppercase tracking-widest font-bold">
            <span>Version {version}</span>
            <span className="w-1.5 h-1.5 rounded-none bg-black dark:bg-white"></span>
            <span>{updated}</span>
          </div>
        )}
      </div>
      <div className="p-8 md:p-16 flex flex-col justify-center items-center h-full relative overflow-hidden bg-brand-primary text-white">
        <div className="absolute top-0 right-0 w-64 h-64 bg-pink-500 rounded-bl-full border-b-[8px] border-l-[8px] border-black dark:border-white" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-brand-secondary rounded-tr-full border-t-[8px] border-r-[8px] border-black dark:border-white" />
        <div className="text-5xl md:text-7xl font-black uppercase tracking-widest text-center relative z-10 leading-[0.9]">
          {label?.split(' ').map((word, i) => (
            <React.Fragment key={i}>
              {i > 0 && i === label.split(' ').length - 1 ? (
                <span className="text-brand-secondary">{word}</span>
              ) : (
                <>{word} <br/></>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};
